module.exports = __webpack_public_path__ + "static/media/Cats eyes 04_ENGELSKA-mixdown.c015d601.mp3";